/**
 * @generated SignedSource<<8a3605aa09a1d7bdf5eecdc42b1e31e4>>
 * @relayHash 513111f95c4dcee22dcaea9fcfca2e21
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2464e55ff444cbe0cbca70c774a1d19093605231f84f49ae790bb8735fefedbf

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type ConfluenceContentAccessRequestStatus = "APPROVE" | "DENY" | "PENDING" | "PENDING_SITE_APPROVAL" | "%future added value";
export type ConfluenceRequestAccessApprovalDecision = "APPROVE" | "DENY" | "%future added value";
export type ResourceAccessType = "EDIT" | "VIEW" | "%future added value";
export type ConfluenceUpdateContentAccessRequestInput = {
  accessRequestedAccountId: string;
  accessType: ResourceAccessType;
  approvalDecision: ConfluenceRequestAccessApprovalDecision;
  contentId: string;
  requestId: string;
};
export type AccessRequestsTableRowMutation$variables = {
  cloudId: string;
  updateContentAccessRequestInput: ConfluenceUpdateContentAccessRequestInput;
};
export type AccessRequestsTableRowMutation$data = {
  readonly confluence_updateContentAccessRequest: {
    readonly errors: ReadonlyArray<{
      readonly __typename: "MutationError";
      readonly extensions: {
        readonly displayName?: string;
        readonly errorType: string | null | undefined;
        readonly processedRequestStatus?: ConfluenceContentAccessRequestStatus;
        readonly statusCode: number | null | undefined;
      } | null | undefined;
      readonly message: string | null | undefined;
    }>;
    readonly success: boolean;
  } | null | undefined;
};
export type AccessRequestsTableRowMutation = {
  response: AccessRequestsTableRowMutation$data;
  variables: AccessRequestsTableRowMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "updateContentAccessRequestInput"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "updateContentAccessRequestInput",
    "variableName": "updateContentAccessRequestInput"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "kind": "ScalarField",
  "name": "errorType"
},
v4 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v5 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "displayName"
    },
    {
      "kind": "ScalarField",
      "name": "processedRequestStatus"
    }
  ],
  "type": "ConfluenceUpdateContentAccessRequestMutationErrorExtension"
},
v6 = {
  "kind": "ScalarField",
  "name": "message"
},
v7 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "AccessRequestsTableRowMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "ConfluenceUpdateContentAccessRequestPayload",
        "kind": "LinkedField",
        "name": "confluence_updateContentAccessRequest",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/)
                ]
              },
              (v6/*: any*/),
              (v7/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AccessRequestsTableRowMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "ConfluenceUpdateContentAccessRequestPayload",
        "kind": "LinkedField",
        "name": "confluence_updateContentAccessRequest",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "id"
                      }
                    ],
                    "type": "BulkMutationErrorExtension"
                  }
                ]
              },
              (v6/*: any*/),
              (v7/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "513111f95c4dcee22dcaea9fcfca2e21",
    "id": "2464e55ff444cbe0cbca70c774a1d19093605231f84f49ae790bb8735fefedbf",
    "metadata": {},
    "name": "AccessRequestsTableRowMutation",
    "operationKind": "mutation",
    "text": "mutation AccessRequestsTableRowMutation($cloudId:ID!,$updateContentAccessRequestInput:ConfluenceUpdateContentAccessRequestInput!){confluence_updateContentAccessRequest(cloudId:$cloudId,updateContentAccessRequestInput:$updateContentAccessRequestInput){success,errors{extensions{__typename,errorType,statusCode,...on ConfluenceUpdateContentAccessRequestMutationErrorExtension{displayName,processedRequestStatus},...on BulkMutationErrorExtension{id}},message,__typename}}}"
  }
};
})();

(node as any).hash = "5bd3c6c3682c02dd5f8f3ccc44471eb7";

export default node;
